import { useEffect } from 'react';
import { useBrand } from '../hooks/useBrand';

export function FaviconManager() {
  const brand = useBrand();

  useEffect(() => {
    let faviconLink = document.querySelector("link[rel~='icon']");

    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }

    faviconLink.href = brand.favicon;

    document.title = brand.meta.title;

    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }

    metaDescription.content = brand.meta.description;
  }, [brand]);

  return null;
}
